import { useIsEnv } from '../../src/contract-portal/client/src/hooks/useIsEnv';

export interface props {
  text: string;
  className?: string;
}

export const Title = (props: props) => {
  const isDev = useIsEnv().isDev;
  return (
    <h1 title={isDev ? 'DevInfo: Title' : ''} className={`text-xl ${props.className}`}>
      {props.text}
    </h1>
  );
};
